import { createSlice } from '@reduxjs/toolkit'
import { getUnique, keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { getPerformanceTrend, getRiskTrend, getTrendConfig } from './thunk'

const initialState = {
  ids: [],
  dataTable: {},
  idsPer: [],
  dataTablePer: {},
  loading: true,
  idsTableChange: [],
  dataTableChange: {},
  fragment: false,
}

const slice = createSlice({
  name: 'portfolio/score/scoreTrend',
  initialState,
  reducers: {
    resetSore: () => initialState,
    changeDataCellTable: (state, action) => {
      const { rowId, colId, data } = action.payload
      state.dataTableChange[rowId][colId] = data
    },
    addItemTableChange: (state, action) => {
      state.dataTableChange = { ...state.dataTableChange, ...action.payload }
      state.idsTableChange = [
        ...state.idsTableChange,
        Object.keys(action.payload)[0],
      ]
    },
    changeFragment: (state) => {
      state.fragment = !state.fragment
    },
    removeTrendConfig: (state, action) => {
      const { rowId } = action.payload
      state.idsTableChange = state.idsTableChange.filter((id) => id !== rowId)
      delete state.dataTableChange[rowId]
    },
  },
  extraReducers: (builder) => {
    //getRiskTrend
    builder.addCase(getRiskTrend.pending, (state) => {
      state.ids = []
      state.dataTable = {}
      state.loading = true
    })
    builder.addCase(getRiskTrend.fulfilled, (state, { payload = [] }) => {
      const data = payload.map((item, index) => ({ ...item, id: index + 1 }))
      state.ids = data.map((item) => item.id)
      state.dataTable = keyBy(data, 'id')
      state.loading = false
    })
    builder.addCase(getRiskTrend.rejected, (state, { payload = [] }) => {
      state.loading = payload.loading
    })
    //getPerformanceTrend
    builder.addCase(getPerformanceTrend.pending, (state) => {
      state.idsPer = []
      state.dataTablePer = {}
      state.loading = true
    })
    builder.addCase(
      getPerformanceTrend.fulfilled,
      (state, { payload = [] }) => {
        const data = payload.map((item, index) => ({ ...item, id: index + 1 }))
        state.idsPer = data.map((item) => item.id)
        state.dataTablePer = keyBy(data, 'id')
        state.loading = false
      },
    )
    builder.addCase(getPerformanceTrend.rejected, (state, { payload = [] }) => {
      state.loading = payload.loading
    })
    //getScoreTrend
    builder.addCase(getTrendConfig.pending, (state) => {
      state.idsTableChange = []
      state.dataTableChange = {}
      state.loading = true
    })
    builder.addCase(getTrendConfig.fulfilled, (state, { payload = [] }) => {
      const data = payload.map((item) => ({ ...item, id: getUnique() }))
      state.idsTableChange = data.map((item) => item.id)
      state.dataTableChange = keyBy(data, 'id')
      state.loading = false
    })
    builder.addCase(getTrendConfig.rejected, (state, { payload = [] }) => {
      state.loading = payload.loading
    })
  },
})

export const selectIdsTable = (state) => state[slice.name].ids
export const getDataTableRedux = (rowId, colId) => (state) =>
  !colId
    ? state[slice.name].dataTable[rowId]
    : state[slice.name].dataTable[rowId][colId]

export const selectIdsTablePer = (state) => state[slice.name].idsPer
export const getDataTablePerRedux = (rowId, colId) => (state) =>
  !colId
    ? state[slice.name].dataTablePer[rowId]
    : state[slice.name].dataTablePer[rowId][colId]

export const getLoadingTrend = (state) => state[slice.name].loading

export const selectIdsTableChange = (state) => state[slice.name].idsTableChange
export const getDataTableChangeRedux = (rowId, colId) => (state) =>
  state[slice.name].dataTableChange[rowId][colId]
export const getDataTableChange = (state) =>
  Object.values(state[slice.name].dataTableChange)
export const getFragment = (state) => state[slice.name].fragment

export const {
  changeDataCellTable,
  resetSore,
  changeFragment,
  addItemTableChange,
  removeTrendConfig,
} = slice.actions

register(slice.name, slice.reducer)
